import { render } from "./ParticlesBackground.vue?vue&type=template&id=b0637ab8&scoped=true"
import script from "./ParticlesBackground.vue?vue&type=script&lang=js"
export * from "./ParticlesBackground.vue?vue&type=script&lang=js"

import "./ParticlesBackground.vue?vue&type=style&index=0&id=b0637ab8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0637ab8"]])

export default __exports__